import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const buttonGroupStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',

		flexWrap: 'nowrap',
		overflowX: 'auto',
		pb: '10px',
	},
	gridItem: {
		minWidth: 'fit-content',
		flexBasis: 'auto !important',
	},
	buttonBox: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',

		backgroundColor: Colors['F7F7F7'],
		borderRadius: '100px',
		marginRight: 0,
		marginLeft: 0,
		border: '2px solid transparent',
		px: { xs: '5px', md: '22px', lg: '5px', xl: '20px' },
		py: { xs: '10px', sm: '14px', md: '18px', lg: '21px', xl: '29px' },
		cursor: 'pointer',
		userSelect: 'none',
		transition: '0.5s background-color ease-in-out',

		fontFamily: 'Integral CF',
		fontWeight: 500,
		fontSize: '24px',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',

		p: { xs: '12px 24px !important' },

		flexShrink: 0,
		minWidth: 'fit-content',

		'&:hover': {
			backgroundColor: Colors['EDEDED'],
		},
	},
	buttonBoxActive: {
		borderColor: Colors['FF6000'],
		backgroundColor: 'white',

		'&:hover': {
			backgroundColor: Colors['F7F7F7'],
		},
	},
	buttonText: {
		color: theme.palette.primary.dark,
		userSelect: 'none',
		fontFamily: 'Integral CF',
		fontWeight: 500,
		lineHeight: 0.85,
		textAlign: 'center',
		fontSize: { xs: '12px', md: '14px', lg: '16px' },
	},
});
